interface PeakPowerEntry { duration: string; durationSeconds: number; power: number; date: string; activityName: string; }
interface PeakPowerTableProps { peaks: PeakPowerEntry[]; }

const DURATIONS = [
  { label: '5s', seconds: 5 }, { label: '10s', seconds: 10 }, { label: '30s', seconds: 30 },
  { label: '1m', seconds: 60 }, { label: '2m', seconds: 120 }, { label: '5m', seconds: 300 },
  { label: '10m', seconds: 600 }, { label: '20m', seconds: 1200 }, { label: '30m', seconds: 1800 }, { label: '60m', seconds: 3600 },
];

export function PeakPowerTable({ peaks }: PeakPowerTableProps) {
  const peakMap = new Map(peaks.map((p) => [p.durationSeconds, p]));
  return (
    <div className="rounded-xl border border-border/60 p-4">
      <h3 className="text-sm font-semibold mb-3">Peak Power Records</h3>
      {peaks.length === 0 ? (
        <div className="py-6 text-center text-muted-foreground text-sm">No peak power data available yet.</div>
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full text-xs">
            <thead>
              <tr className="border-b border-border/40">
                <th className="text-left py-2 text-muted-foreground font-medium">Duration</th>
                <th className="text-right py-2 text-muted-foreground font-medium">Power</th>
                <th className="text-right py-2 text-muted-foreground font-medium hidden sm:table-cell">Date</th>
                <th className="text-right py-2 text-muted-foreground font-medium hidden md:table-cell">Activity</th>
              </tr>
            </thead>
            <tbody>
              {DURATIONS.map(({ label, seconds }) => {
                const peak = peakMap.get(seconds);
                return (
                  <tr key={seconds} className="border-b border-border/20">
                    <td className="py-2 font-medium text-foreground">{label}</td>
                    <td className="py-2 text-right tabular-nums font-bold text-foreground">{peak ? `${peak.power}W` : '—'}</td>
                    <td className="py-2 text-right text-muted-foreground hidden sm:table-cell">{peak?.date?.slice(0, 10) ?? '—'}</td>
                    <td className="py-2 text-right text-muted-foreground hidden md:table-cell truncate max-w-[150px]">{peak?.activityName ?? '—'}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
